import { render, staticRenderFns } from "./solicitud-reporte-comunitario.vue?vue&type=template&id=03319b67&"
import script from "./solicitud-reporte-comunitario.vue?vue&type=script&lang=ts&"
export * from "./solicitud-reporte-comunitario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports